function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.327 24l-1.8-5.69H7.473L5.673 24H0L8.764 0h6.438L24 24h-5.673zm-3.057-9.94c-1.665-5.155-2.605-8.07-2.82-8.747a26.648 26.648 0 01-.441-1.602c-.374 1.395-1.444 4.845-3.21 10.349h6.47z"
});

function SvgString(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgString;